import './viz.css'

interface ProgressBarProps {
  value: number
  max: number
  tone?: 'brand' | 'gain' | 'warn' | 'loss'
  marker?: number
  ariaLabel: string
}

const clampPct = (pct: number) => Math.min(100, Math.max(0, pct))

/** Thin horizontal gauge; an optional marker shows a threshold on the track. */
export function ProgressBar({ value, max, tone = 'brand', marker, ariaLabel }: ProgressBarProps) {
  const fillPct = max > 0 ? clampPct((value / max) * 100) : 0
  const markerPct = marker !== undefined && max > 0 ? clampPct((marker / max) * 100) : undefined

  return (
    <div className="viz-bar" role="img" aria-label={ariaLabel}>
      <div className={`viz-bar-fill viz-bar-fill--${tone}`} style={{ width: `${fillPct}%` }} />
      {markerPct !== undefined && (
        <div className="viz-bar-marker" style={{ left: `${markerPct}%` }} />
      )}
    </div>
  )
}
